import client from './client';

const eqpUrl = '/api/v1/eqp';

// ============================= 매거진(공구 매거진) 현황판 =============================
// 저장(공구 교환 이력/매거진 매핑)은 에이전트 snapshot 경로에서 서버가 알아서 한다 - 화면은 읽기만.

export const getMagazine = (eqpUuid) =>
  client.get(`${eqpUrl}/${eqpUuid}/magazine`);

export const extractInfo = (res) => res?.data?.info ?? null;
